import React, { useEffect } from "react";
import { CiClock2 } from "react-icons/ci";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { QBSubjectnames } from "../../ReusableComponents/CommonFunctions";
// Below is for import the components
import CopyRight from "../../Student/Reusablecomponents/Copyright";
import ScenarioQuestionformat from "../../Student/Reusablecomponents/ScenarioQuestionformat";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { FaCaretRight, FaCaretLeft } from "react-icons/fa";
import WithTranslate from "../../ReusableComponents/StaticTranslater/Translater";
import { CheckLanguage } from "../../ReusableComponents/CommonFunctions";

const PreviewQuestion = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const GetQuestion = useSelector(
    (state) => state.QuestionDeatils.QuestionDetails
  );
  const Scenario = useSelector(
    (state) => state.ScenarioDeatils.ScenarioDetails
  );
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );

  const requestFullScreen = async () => {
    try {
      await document.documentElement.requestFullscreen();
    } catch (err) {
      console.error(
        `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
      );
    }
  };

  const ExitFullScreen = () => {
    if (!document.fullscreenElement) {
      navigate(-1);
    }
  };

  const listener = () => {
    if (!document.hasFocus()) {
      ExitFullScreen();
      if (localStorage.getItem("timeupAlertShown") === null) {
        alert(process.env.REACT_APP_ASSESSMENTWINDOWTABCLOSE);
      }
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    requestFullScreen();

    document.addEventListener("fullscreenchange", ExitFullScreen);

    return () => {
      document.removeEventListener("fullscreenchange", ExitFullScreen);
    };
  }, []);

  const BackgroundBG = () => {
    switch (QBSubjectnames(items.subjectId)) {
      case "English":
        return "EnglishBGAswersheet";
      case "Mathematics":
        return "MathsBGAswersheet";
      case "Biology":
        return "BiologyBGAswersheet";
      default:
        return "ScienceBGAswersheet";
    }
  };

  return (
    <div className={`Aswersheet-maindiv ${BackgroundBG()}`}>
      <InternetChecking />
      <div className="dflex COlDiv">
        <div className="AButtonsDiv">
          <span className="BQuestion">Question</span>
          <div className="Buttons-Maindiv  dflex flexd-column alignitems">
            <div className="Display-Buttons">
              {[...Array(16)].map((_, index) => (
                <button key={index + 1}> {index + 1} </button>
              ))}
            </div>
            <hr style={{ width: "100%" }} />
            <div className="Answer-Details">
              {" "}
              <span>Answered</span> <span>Reviewed</span> <span>Not seen</span>{" "}
            </div>
            <button className="ReviewSubmit Buttons Poppins">
              Review & Submit
            </button>
          </div>
          <div className="Answersheet-Instructions">
            <p>
              {" "}
              <strong>
                Please attempt at least one question(s) to 'Submit'.
              </strong>
            </p>

            <p className="text-danger">
              Please do not switch between the tabs/windows, the assessment
              might be terminated
            </p>
            <p className="text-danger">
              Don't close the assessment window until you complete the
              assessment.
            </p>
            <p>
              Please don't click 'Submit' button in the pop up multiple times.
              Wait until the next Question Paper loads after clicking the submit
              button once.
            </p>
          </div>
        </div>
        <div>
          <div className="Question-Answers">
            <div className="ExamTime-Details dflex alignitems">
              <span>Subject : {QBSubjectnames(items.subjectId)}</span>
              <span>Duration : 30 min</span>
              <div className="Timeleft dflex alignitems">
                <span>
                  <CiClock2 />
                </span>
                <div className="Runningtime dflex flexd-column">
                  <div> 22:35 </div> <span>Time Left</span>
                </div>{" "}
              </div>
            </div>

            <div className="Questions-Maindiv">
              <div className="Questions dflex flexd-column">
                {Scenario && (
                  <span>
                    <b> Scenario:</b>{" "}
                    <ScenarioQuestionformat scenario={Scenario?.scenarioName} />
                  </span>
                )}

                <span className="dflex">
                  <b style={{ textWrap: "nowrap" }}>Question :</b>{" "}
                  <ScenarioQuestionformat scenario={GetQuestion?.question} />
                </span>
              </div>
              {GetQuestion.qType === "D" || location.state?.Tab === "INQ" ? (
                <div className="dflex gap-3 ">
                  <b>Answer : </b>

                  <div className="dflex gap-2 flexd-column">
                    {GetQuestion?.answerValType === "M" ? (
                      Array.from({
                        length: GetQuestion?.answer?.split(",").length,
                      }).map((_, index) => (
                        <input type="text" className="Search" />
                      ))
                    ) : (
                      <textarea
                        placeholder="Enter Your Answer"
                        rows="3"
                        cols="50"
                      />
                    )}
                  </div>
                </div>
              ) : (
                ["A", "B", "C", "D"].map((option, index) => (<>
                  {GetQuestion?.[`option${option}`] && 
                  <div className="Question-Options dflex">
                    <input type="radio" name="Perview" value={option} />
                    <span className="dflex MOptions">
                      {option})&nbsp;{" "}
                      <ScenarioQuestionformat
                        scenario={GetQuestion?.[`option${option}`]}
                      />
                    </span> 
                  </div>}
                  </>
                ))
              )}

              <div className="Change-Questions dflex alignitems">
                <button>
                  <FaCaretLeft />
                  Previous Question
                </button>
                <button>
                  Next Question <FaCaretRight />
                </button>
              </div>

              <div className="mt-4" style={{ color: "#4D4DEF" }}>
                {/* <b>Note : </b>You are required to spend a minimum of 10 minutes
                on each subject. Please make sure all the questions and check
                your answers to improve your score. */}
                <b>
                  {" "}
                  <WithTranslate
                    name="Preview.NoticeHeading"
                    Medium={CheckLanguage(SelectLanguage) ? "Hindi" : "English"}
                  />
                </b>
                <WithTranslate
                  name="Preview.NoticeText"
                  Medium={CheckLanguage(SelectLanguage) ? "Hindi" : "English"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PreviewQuestion;
